export default function CourseOffering() {
    return (
        <>
            <section id="course-offering-section">
                <div className="course-offering-container">
                    <div className="course-offering-header">
                        <h2 className="section-title">Choose Your Learning Path</h2>
                        <p className="section-subtitle">Select the learning mode that best fits your lifestyle and goals</p>
                    </div>

                    <div className="course-offering-content">
                        <div className="course-offering-grid">
                            <div className="course-offering-card">
                                <div className="card-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                        <line x1="8" y1="21" x2="16" y2="21" />
                                        <line x1="12" y1="17" x2="12" y2="21" />
                                    </svg>
                                </div>

                                <div className="card-content">
                                    <h3 className="card-title">ONLINE LEARNING</h3>
                                    <p className="card-description">Experience world-class music education from the comfort of your home. Our online courses are designed for flexibility, interaction, and progress, providing structured, personal coaching accessible anytime.</p>

                                    <div className="card-features">
                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Live Virtual Classes with expert instructors</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">High-Quality Video & Audio Setup for immersive learning</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Flexible Scheduling — learn at your convenience</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Global Community of learners and performers</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Trackable Class Records and Assignments</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Certification Courses (Trinity, ABRSM, Rockschool, etc.)</span>
                                        </div>
                                    </div>

                                    {/* <div className="card-cta">
                                        <button className="cta-button online-cta">Start Online Learning</button>
                                    </div> */}
                                </div>
                            </div>

                            <div className="course-offering-card">
                                <div className="card-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M9 18V5l12-2v13" />
                                        <circle cx="6" cy="18" r="3" />
                                        <circle cx="18" cy="16" r="3" />
                                    </svg>
                                </div>

                                <div className="card-content">
                                    <h3 className="card-title">OFFLINE LEARNING (Jaipur Campus)</h3>
                                    <p className="card-description">Where creativity meets collaboration. Our Jaipur academy offers a musically rich, hands-on environment guided by professionals, serving as a hub for passionate musicians.</p>

                                    <div className="card-features">
                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Professional Classrooms & Recording Studios</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">In-Person Mentorship with Expert Musicians</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Live Jamming, Recitals & Stage Performance Opportunities</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Structured Curriculum with Certification Support (Trinity, ABRSM, Rockschool, etc.)</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Collaborative Learning with Fellow Musicians</span>
                                        </div>

                                        <div className="feature-item">
                                            <div className="feature-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12" />
                                                </svg>
                                            </div>
                                            <span className="feature-text">Workshops, Masterclasses & Exclusive Artist Interactions</span>
                                        </div>
                                    </div>

                                    {/* <div className="card-cta">
                                        <button className="cta-button offline-cta">Visit Our Studio</button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 